module.exports = __webpack_public_path__ + "static/media/close-icon.79b5b3f0.svg";